import React from "react";

interface TestSubmissionButtonProps {
  onClick: () => void;
  disabled: boolean;
  orderMode: "random" | "curve";
}

export const TestSubmissionButton: React.FC<TestSubmissionButtonProps> = ({
  onClick,
  disabled,
  orderMode,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="trading-test-button trading-test-button-primary"
      style={{
        backgroundColor: disabled ? "#ccc" : "#007bff",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      Submit Test Orders ({orderMode === "random" ? "Random" : "Curve-Based"})
    </button>
  );
};

interface ChartOrderSubmissionButtonProps {
  onClick: () => void;
  disabled: boolean;
  orderCount: number;
}

export const ChartOrderSubmissionButton: React.FC<
  ChartOrderSubmissionButtonProps
> = ({ onClick, disabled, orderCount }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="trading-test-button trading-test-button-success"
      style={{
        backgroundColor: disabled ? "#ccc" : "#28a745",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      Submit Chart Orders ({orderCount} orders)
    </button>
  );
};

interface ResetChartButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export const ResetChartButton: React.FC<ResetChartButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="trading-test-button trading-test-button-secondary"
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      Reset Chart
    </button>
  );
};

interface LoadPendingOrdersButtonProps {
  onClick: () => void;
  disabled: boolean;
  pendingCount: number;
}

export const LoadPendingOrdersButton: React.FC<
  LoadPendingOrdersButtonProps
> = ({ onClick, disabled, pendingCount }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="trading-test-button trading-test-button-info"
      style={{
        backgroundColor: disabled ? "#ccc" : "#17a2b8",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      Load Pending Orders {pendingCount > 0 && `(${pendingCount})`}
    </button>
  );
};

interface CancelAllOrdersButtonProps {
  onClick: () => void;
  disabled: boolean;
  filter: "long" | "short" | "all";
}

export const CancelAllOrdersButton: React.FC<CancelAllOrdersButtonProps> = ({
  onClick,
  disabled,
  filter,
}) => {
  const label =
    filter === "long"
      ? "Cancel All Long"
      : filter === "short"
        ? "Cancel All Short"
        : "Cancel All Orders";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="trading-test-button trading-test-button-danger"
      style={{
        backgroundColor: disabled ? "#ccc" : "#dc3545",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {label}
    </button>
  );
};
